<template>
  <div>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <DxHtmlEditor
          dir="auto"
          :settings-allow-html-view="false"
          style="max-height: 500px;min-height: 200px;"
          v-model="editorContent"
          :placeholder="$t('mail.writeHere')"
          ref="DxHtmlEditorContent"
        >
          <DxTableContextMenu :enabled="true" />
          <DxTableResizing :enabled="true" />
          <DxMediaResizing :enabled="true" />
          <DxImageUpload :tabs="['file', 'url']" file-upload-mode="base64" />
          <DxToolbar :multiline="false">
            <DxItem name="undo" />
            <DxItem name="redo" />
            <DxItem name="separator" />
            <DxItem :accepted-values="sizeValues" name="size" />
            <DxItem :accepted-values="fontValues" name="font" />
            <DxItem name="separator" />
            <DxItem name="bold" />
            <DxItem name="italic" />
            <DxItem name="strike" />
            <DxItem name="underline" />
            <DxItem name="separator" />
            <DxItem name="alignLeft" />
            <DxItem name="alignCenter" />
            <DxItem name="alignRight" />
            <DxItem name="alignJustify" />
            <DxItem name="separator" />
            <DxItem name="orderedList" />
            <DxItem name="bulletList" />
            <DxItem name="separator" />
            <DxItem :accepted-values="headerValues" name="header" />
            <DxItem name="separator" />
            <DxItem name="color" />
            <DxItem name="background" />
            <DxItem name="separator" />
            <DxItem name="link" />
            <!-- <DxItem
                widget="dxButton"
                :options="checkboxOptions"
                locate-in-menu="never"
              /> -->
            <DxItem name="image" />
            <DxItem name="separator" />
            <DxItem name="clear" />
            <DxItem name="codeBlock" />
            <DxItem name="blockquote" />
            <DxItem name="separator" />
            <DxItem name="insertTable" />
            <DxItem name="deleteTable" />
            <DxItem name="insertRowAbove" />
            <DxItem name="insertRowBelow" />
            <DxItem name="deleteRow" />
            <DxItem name="insertColumnLeft" />
            <DxItem name="insertColumnRight" />
            <DxItem name="deleteColumn" />
          </DxToolbar>
        </DxHtmlEditor>
      </v-tab-item>
      <v-tab-item>
        <v-card color="basil" outlined flat max-height="500px" min-height="200px" style="overflow-y: auto">
          <div dir="auto" class="ma-3" v-html="getYoutube(editorContent)"></div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <v-tabs v-model="tab">
      <v-tab>
        {{ $t("Editor") }}
      </v-tab>
      <v-tab>{{ $t("Preview") }}</v-tab>
    </v-tabs>
  </div>
</template>
<script>
import {
  DxHtmlEditor,
  DxToolbar,
  DxMediaResizing,
  DxTableResizing,
  DxTableContextMenu,
  DxItem,
  DxImageUpload
} from "devextreme-vue/html-editor";

export default {
  components: {
    DxHtmlEditor,
    DxToolbar,
    DxMediaResizing,
    DxTableResizing,
    DxTableContextMenu,
    DxItem,
    DxImageUpload
  },
  name: "CustomHtmlEditor",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editorContent: this.value,
      tab: 0,
      headerValues: [false, 1, 2, 3, 4, 5],
       fontValues: [
        "Arial",
        "Courier New",
        "Georgia",
        "Impact",
        "Lucida Console",
        "Tahoma",
        "Times New Roman",
        "Verdana"
      ],
      sizeValues: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"],


    };
  },
  watch: {
    value(newValue) {
      this.editorContent = newValue;
    }
  },
  watch: {
    value(newValue) {
      this.editorContent = newValue;
    },
    editorContent(newContent) {
      this.$emit("input", newContent);
      this.$emit("update:value", newContent); // for v-model compatibility
    }
  },
};
</script>
